//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { AuthorizedApiClientBase } from "../../../../components/Auth/AuthorizedApiClientBase";

export class EducationClient extends AuthorizedApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Record a completion of the financial confidence quiz
     * @return Success
     */
    financialConfidenceQuizComplete(request: FinancialConfidenceQuizComplete_Request): Promise<FinancialConfidenceQuizComplete_Response> {
        let url_ = this.baseUrl + "/api/education/financial-confidence-quiz";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFinancialConfidenceQuizComplete(_response);
        });
    }

    protected processFinancialConfidenceQuizComplete(response: Response): Promise<FinancialConfidenceQuizComplete_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FinancialConfidenceQuizComplete_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FinancialConfidenceQuizComplete_Response>(null as any);
    }

    /**
     * Record a completion of the financial literacy quiz
     * @return Success
     */
    financialLiteracyQuizComplete(request: FinancialLiteracyQuizComplete_Request): Promise<FinancialLiteracyQuizComplete_Response> {
        let url_ = this.baseUrl + "/api/education/financial-literacy-quiz";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFinancialLiteracyQuizComplete(_response);
        });
    }

    protected processFinancialLiteracyQuizComplete(response: Response): Promise<FinancialLiteracyQuizComplete_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FinancialLiteracyQuizComplete_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FinancialLiteracyQuizComplete_Response>(null as any);
    }

    /**
     * @return Success
     */
    getCourses(): Promise<GetCourses_Response> {
        let url_ = this.baseUrl + "/api/education/courses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCourses(_response);
        });
    }

    protected processGetCourses(response: Response): Promise<GetCourses_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCourses_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCourses_Response>(null as any);
    }

    /**
     * Get the latest financial confidence quiz score
     * @return Success
     */
    getLatestFinancialConfidenceQuizScore(): Promise<GetLatestFinancialConfidenceQuizScore_Response> {
        let url_ = this.baseUrl + "/api/education/financial-confidence-quiz/latest";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLatestFinancialConfidenceQuizScore(_response);
        });
    }

    protected processGetLatestFinancialConfidenceQuizScore(response: Response): Promise<GetLatestFinancialConfidenceQuizScore_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLatestFinancialConfidenceQuizScore_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetLatestFinancialConfidenceQuizScore_Response>(null as any);
    }

    /**
     * Get the latest financial literacy quiz score
     * @return Success
     */
    getLatestFinancialLiteracyQuizScore(): Promise<GetLatestFinancialLiteracyQuizScore_Response> {
        let url_ = this.baseUrl + "/api/education/financial-literacy-quiz/latest";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLatestFinancialLiteracyQuizScore(_response);
        });
    }

    protected processGetLatestFinancialLiteracyQuizScore(response: Response): Promise<GetLatestFinancialLiteracyQuizScore_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLatestFinancialLiteracyQuizScore_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetLatestFinancialLiteracyQuizScore_Response>(null as any);
    }

    /**
     * @return Success
     */
    markTopicComplete(request: MarkTopicComplete_Request, courseId: number, levelId: number): Promise<any> {
        let url_ = this.baseUrl + "/api/education/courses/{CourseId}/levels/{LevelId}/complete-topic";
        if (courseId === undefined || courseId === null)
            throw new Error("The parameter 'courseId' must be defined.");
        url_ = url_.replace("{CourseId}", encodeURIComponent("" + courseId));
        if (levelId === undefined || levelId === null)
            throw new Error("The parameter 'levelId' must be defined.");
        url_ = url_.replace("{LevelId}", encodeURIComponent("" + levelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMarkTopicComplete(_response);
        });
    }

    protected processMarkTopicComplete(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return Success
     */
    recordQuizAnswers(request: RecordQuizAnswers_Request, quizId: number | null): Promise<any> {
        let url_ = this.baseUrl + "/api/education/quiz/{QuizId}/answers";
        if (quizId === undefined || quizId === null)
            throw new Error("The parameter 'quizId' must be defined.");
        url_ = url_.replace("{QuizId}", encodeURIComponent("" + quizId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRecordQuizAnswers(_response);
        });
    }

    protected processRecordQuizAnswers(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return Success
     */
    recordTopicProgress(request: RecordTopicProgress_Request, courseId: number, levelId: number, topicId: number): Promise<any> {
        let url_ = this.baseUrl + "/api/education/courses/{CourseId}/levels/{LevelId}/topics/{TopicId}/progress";
        if (courseId === undefined || courseId === null)
            throw new Error("The parameter 'courseId' must be defined.");
        url_ = url_.replace("{CourseId}", encodeURIComponent("" + courseId));
        if (levelId === undefined || levelId === null)
            throw new Error("The parameter 'levelId' must be defined.");
        url_ = url_.replace("{LevelId}", encodeURIComponent("" + levelId));
        if (topicId === undefined || topicId === null)
            throw new Error("The parameter 'topicId' must be defined.");
        url_ = url_.replace("{TopicId}", encodeURIComponent("" + topicId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRecordTopicProgress(_response);
        });
    }

    protected processRecordTopicProgress(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }
}

export class FinancialConfidenceQuizComplete_Response implements IFinancialConfidenceQuizComplete_Response {
    score?: number;

    constructor(data?: IFinancialConfidenceQuizComplete_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.score = _data["score"];
        }
    }

    static fromJS(data: any): FinancialConfidenceQuizComplete_Response {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialConfidenceQuizComplete_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["score"] = this.score;
        return data;
    }
}

export interface IFinancialConfidenceQuizComplete_Response {
    score?: number;
}

/** the dto used to send an error response to the client */
export class FastEndpointsErrorResponse implements IFastEndpointsErrorResponse {
    /** the http status code sent to the client. default is 400. */
    statusCode?: number;
    /** the message for the error response */
    message?: string;
    /** the collection of errors for the current context */
    errors?: { [key: string]: string[]; };

    constructor(data?: IFastEndpointsErrorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.message = _data["message"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (<any>this.errors)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): FastEndpointsErrorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FastEndpointsErrorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["message"] = this.message;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (<any>data["errors"])[key] = (<any>this.errors)[key];
            }
        }
        return data;
    }
}

/** the dto used to send an error response to the client */
export interface IFastEndpointsErrorResponse {
    /** the http status code sent to the client. default is 400. */
    statusCode?: number;
    /** the message for the error response */
    message?: string;
    /** the collection of errors for the current context */
    errors?: { [key: string]: string[]; };
}

export class FinancialConfidenceQuizComplete_Request implements IFinancialConfidenceQuizComplete_Request {
    numLow?: number;
    numMedium?: number;
    numHigh?: number;

    constructor(data?: IFinancialConfidenceQuizComplete_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numLow = _data["numLow"];
            this.numMedium = _data["numMedium"];
            this.numHigh = _data["numHigh"];
        }
    }

    static fromJS(data: any): FinancialConfidenceQuizComplete_Request {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialConfidenceQuizComplete_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numLow"] = this.numLow;
        data["numMedium"] = this.numMedium;
        data["numHigh"] = this.numHigh;
        return data;
    }
}

export interface IFinancialConfidenceQuizComplete_Request {
    numLow?: number;
    numMedium?: number;
    numHigh?: number;
}

export class FinancialLiteracyQuizComplete_Response implements IFinancialLiteracyQuizComplete_Response {
    score?: number;

    constructor(data?: IFinancialLiteracyQuizComplete_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.score = _data["score"];
        }
    }

    static fromJS(data: any): FinancialLiteracyQuizComplete_Response {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialLiteracyQuizComplete_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["score"] = this.score;
        return data;
    }
}

export interface IFinancialLiteracyQuizComplete_Response {
    score?: number;
}

export class FinancialLiteracyQuizComplete_Request implements IFinancialLiteracyQuizComplete_Request {
    numCorrect?: number;

    constructor(data?: IFinancialLiteracyQuizComplete_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numCorrect = _data["numCorrect"];
        }
    }

    static fromJS(data: any): FinancialLiteracyQuizComplete_Request {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialLiteracyQuizComplete_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numCorrect"] = this.numCorrect;
        return data;
    }
}

export interface IFinancialLiteracyQuizComplete_Request {
    numCorrect?: number;
}

export class GetCourses_Response implements IGetCourses_Response {
    courses?: GetCourses_Response_CourseResponse[] | undefined;

    constructor(data?: IGetCourses_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["courses"])) {
                this.courses = [] as any;
                for (let item of _data["courses"])
                    this.courses!.push(GetCourses_Response_CourseResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCourses_Response {
        data = typeof data === 'object' ? data : {};
        let result = new GetCourses_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.courses)) {
            data["courses"] = [];
            for (let item of this.courses)
                data["courses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCourses_Response {
    courses?: GetCourses_Response_CourseResponse[] | undefined;
}

export class GetCourses_Response_CourseResponse implements IGetCourses_Response_CourseResponse {
    courseId?: number;
    levels?: GetCourses_Response_LevelResponse[] | undefined;

    constructor(data?: IGetCourses_Response_CourseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseId = _data["courseId"];
            if (Array.isArray(_data["levels"])) {
                this.levels = [] as any;
                for (let item of _data["levels"])
                    this.levels!.push(GetCourses_Response_LevelResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCourses_Response_CourseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCourses_Response_CourseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseId"] = this.courseId;
        if (Array.isArray(this.levels)) {
            data["levels"] = [];
            for (let item of this.levels)
                data["levels"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCourses_Response_CourseResponse {
    courseId?: number;
    levels?: GetCourses_Response_LevelResponse[] | undefined;
}

export class GetCourses_Response_LevelResponse implements IGetCourses_Response_LevelResponse {
    levelId?: number;
    topics?: GetCourses_Response_TopicResponse[] | undefined;

    constructor(data?: IGetCourses_Response_LevelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.levelId = _data["levelId"];
            if (Array.isArray(_data["topics"])) {
                this.topics = [] as any;
                for (let item of _data["topics"])
                    this.topics!.push(GetCourses_Response_TopicResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCourses_Response_LevelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCourses_Response_LevelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["levelId"] = this.levelId;
        if (Array.isArray(this.topics)) {
            data["topics"] = [];
            for (let item of this.topics)
                data["topics"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCourses_Response_LevelResponse {
    levelId?: number;
    topics?: GetCourses_Response_TopicResponse[] | undefined;
}

export class GetCourses_Response_TopicResponse implements IGetCourses_Response_TopicResponse {
    topicId?: number;
    currentUnitId?: number | undefined;
    isComplete?: boolean;

    constructor(data?: IGetCourses_Response_TopicResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.topicId = _data["topicId"];
            this.currentUnitId = _data["currentUnitId"];
            this.isComplete = _data["isComplete"];
        }
    }

    static fromJS(data: any): GetCourses_Response_TopicResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCourses_Response_TopicResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["topicId"] = this.topicId;
        data["currentUnitId"] = this.currentUnitId;
        data["isComplete"] = this.isComplete;
        return data;
    }
}

export interface IGetCourses_Response_TopicResponse {
    topicId?: number;
    currentUnitId?: number | undefined;
    isComplete?: boolean;
}

export class GetLatestFinancialConfidenceQuizScore_Response implements IGetLatestFinancialConfidenceQuizScore_Response {
    score?: number;

    constructor(data?: IGetLatestFinancialConfidenceQuizScore_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.score = _data["score"];
        }
    }

    static fromJS(data: any): GetLatestFinancialConfidenceQuizScore_Response {
        data = typeof data === 'object' ? data : {};
        let result = new GetLatestFinancialConfidenceQuizScore_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["score"] = this.score;
        return data;
    }
}

export interface IGetLatestFinancialConfidenceQuizScore_Response {
    score?: number;
}

export class GetLatestFinancialLiteracyQuizScore_Response implements IGetLatestFinancialLiteracyQuizScore_Response {
    score?: number;

    constructor(data?: IGetLatestFinancialLiteracyQuizScore_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.score = _data["score"];
        }
    }

    static fromJS(data: any): GetLatestFinancialLiteracyQuizScore_Response {
        data = typeof data === 'object' ? data : {};
        let result = new GetLatestFinancialLiteracyQuizScore_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["score"] = this.score;
        return data;
    }
}

export interface IGetLatestFinancialLiteracyQuizScore_Response {
    score?: number;
}

/** Records progress of a customer completing a topic within a course level. This endpoint is typically called when a changes page within a topic. Recording that the same page has been hit multiple times is supported (in the case of backwards and forward navigation through the topic) */
export class MarkTopicComplete_Request implements IMarkTopicComplete_Request {
    topicId?: number;

    constructor(data?: IMarkTopicComplete_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.topicId = _data["topicId"];
        }
    }

    static fromJS(data: any): MarkTopicComplete_Request {
        data = typeof data === 'object' ? data : {};
        let result = new MarkTopicComplete_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["topicId"] = this.topicId;
        return data;
    }
}

/** Records progress of a customer completing a topic within a course level. This endpoint is typically called when a changes page within a topic. Recording that the same page has been hit multiple times is supported (in the case of backwards and forward navigation through the topic) */
export interface IMarkTopicComplete_Request {
    topicId?: number;
}

export class RecordQuizAnswers_Request implements IRecordQuizAnswers_Request {
    answers!: RecordQuizAnswers_Request_Answer[];

    constructor(data?: IRecordQuizAnswers_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.answers = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(RecordQuizAnswers_Request_Answer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RecordQuizAnswers_Request {
        data = typeof data === 'object' ? data : {};
        let result = new RecordQuizAnswers_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRecordQuizAnswers_Request {
    answers: RecordQuizAnswers_Request_Answer[];
}

export class RecordQuizAnswers_Request_Answer implements IRecordQuizAnswers_Request_Answer {
    questionId!: number;
    givenAnswer!: string;
    correctAnswer!: string;

    constructor(data?: IRecordQuizAnswers_Request_Answer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionId = _data["questionId"];
            this.givenAnswer = _data["givenAnswer"];
            this.correctAnswer = _data["correctAnswer"];
        }
    }

    static fromJS(data: any): RecordQuizAnswers_Request_Answer {
        data = typeof data === 'object' ? data : {};
        let result = new RecordQuizAnswers_Request_Answer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionId"] = this.questionId;
        data["givenAnswer"] = this.givenAnswer;
        data["correctAnswer"] = this.correctAnswer;
        return data;
    }
}

export interface IRecordQuizAnswers_Request_Answer {
    questionId: number;
    givenAnswer: string;
    correctAnswer: string;
}

/** Records progress of a customer completing a topic within a course level. This endpoint is typically called when a changes page within a topic. Recording that the same page has been hit multiple times is supported (in the case of backwards and forward navigation through the topic) */
export class RecordTopicProgress_Request implements IRecordTopicProgress_Request {
    currentUnitId?: number;

    constructor(data?: IRecordTopicProgress_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentUnitId = _data["currentUnitId"];
        }
    }

    static fromJS(data: any): RecordTopicProgress_Request {
        data = typeof data === 'object' ? data : {};
        let result = new RecordTopicProgress_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentUnitId"] = this.currentUnitId;
        return data;
    }
}

/** Records progress of a customer completing a topic within a course level. This endpoint is typically called when a changes page within a topic. Recording that the same page has been hit multiple times is supported (in the case of backwards and forward navigation through the topic) */
export interface IRecordTopicProgress_Request {
    currentUnitId?: number;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}